"use client";

import dynamic from "next/dynamic";

export const Newsletter = dynamic(() => import("./Newsletter").then((mod) => mod.Newsletter));
